import CONST from '../../../../../includes/primitives/_constant_demo'
export default {
  data: () => ({

    HOST: CONST.HOST_NAME_RESOURCE + '/resources',

    canvasForms:  null,
    canvasSVG:    null,
    rawData:      null,

    current: {svg: 'LC_01'},
    
  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {

    set_Gradients() {

    },
  
  }
}